import { c as _c } from "react/compiler-runtime";
import { checkLengthForInput } from '@lib/tools/_check-length-for-input';
import formatLongPrice from '@lib/tools/_format-long-price';
import { useEffect, useState } from 'react';
const useInputValue = (textValue, max, switchPercent) => {
  const $ = _c(8);
  const [inputValue, setInputValue] = useState("");
  const [inputWidth, setInputWidth] = useState(0);
  let t0;
  let t1;
  if ($[0] !== max || $[1] !== switchPercent || $[2] !== textValue) {
    t0 = () => {
      const calculatedValue = switchPercent ? Math.floor(Number(textValue) / Number(max) * 100) : formatLongPrice(textValue);
      setInputValue(calculatedValue);
      setInputWidth(checkLengthForInput(calculatedValue));
    };
    t1 = [textValue, max, switchPercent];
    $[0] = max;
    $[1] = switchPercent;
    $[2] = textValue;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== inputValue || $[6] !== inputWidth) {
    t2 = {
      inputValue,
      setInputValue,
      inputWidth,
      setInputWidth
    };
    $[5] = inputValue;
    $[6] = inputWidth;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default useInputValue;